import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const OneDriveIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props} customFill={preserveColor}>
    <path fill="#fff" d="M0 0h32v32H0z" />
    <path
      fill="#0364B8"
      d="m18.448 18.632 4.85-4.639A7.344 7.344 0 0 0 10.05 11.78c.075-.002 8.398 6.852 8.398 6.852Z"
    />
    <path
      fill="#0078D4"
      d="M13.211 12.654a5.847 5.847 0 0 0-3.086-.876l-.075.002a5.872 5.872 0 0 0-4.745 9.231l7.268-.91 5.571-4.493-4.933-2.954Z"
    />
    <path
      fill="#1490DF"
      d="M23.298 13.993a4.756 4.756 0 0 0-2.214.379l-2.94 1.236 3.24 4.003 5.794 1.409a4.773 4.773 0 0 0-3.88-7.027Z"
    />
    <path
      fill="#28A8EA"
      d="M5.306 21.011a5.867 5.867 0 0 0 4.819 2.517h12.851c1.756 0 3.37-.963 4.202-2.508l-9.034-5.412-12.838 5.403Z"
    />
  </BaseIcon>
);
